import * as Yup from 'yup';
import { Shape } from '../../yup_types';
import { PASSWORD_REG_EXP } from '../../../components/auth/PasswordStrength/PasswordStrength';

export enum CHANGE_PASSWORD_FORM_FIELDS {
	OLD_PASS = 'currentPassword',
	NEW_PASSWORD = 'newPassword',
	CONFIRM_PASSWORD = 'confirmPassword'
}

export enum CHANGE_PASSWORD_FORM_FIELDS_NAMES {
	OLD_PASS = 'Current password',
	NEW_PASSWORD = 'New password',
	// CONFIRM_PASSWORD = 'CONFIRM_PASSWORD.CONFIRM_NEW_PASSWORD_PLACEHOLDER'
	CONFIRM_PASSWORD = 'Confirm password'
}

export type ChangePasswordFieldsType = {
	[CHANGE_PASSWORD_FORM_FIELDS.OLD_PASS]: string,
	[CHANGE_PASSWORD_FORM_FIELDS.NEW_PASSWORD]: string,
	[CHANGE_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD]: string,
}

export type ChangePasswordFieldsReturnType = {
	currentPassword: string,
	newPassword: string,
}

export const getChangePasswordDetailSchema = (t): Yup.SchemaOf<ChangePasswordFieldsType> => Yup.object<Shape<ChangePasswordFieldsType>>().shape({
	[CHANGE_PASSWORD_FORM_FIELDS.OLD_PASS]: Yup.string()
		.required('Current password is required'),
	[CHANGE_PASSWORD_FORM_FIELDS.NEW_PASSWORD]: Yup.string()
		.matches(PASSWORD_REG_EXP.latter, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION1'))
		.matches(PASSWORD_REG_EXP.uppercase, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION2'))
		.matches(PASSWORD_REG_EXP.number, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION3'))
		.matches(PASSWORD_REG_EXP.symbol, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION4'))
		.matches(PASSWORD_REG_EXP.complete, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION5'))
		.min(8, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION6'))
		.max(50, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION7'))
		// .required(t('CONFIRM_PASSWORD.NEW_PASSWORD_REQUIRED')),
		.required('New password is required'),
	[CHANGE_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD]: Yup.string()
		.oneOf([Yup.ref('newPassword'), null], t('CONFIRM_PASSWORD.PASSWORD_MATCH'))
		.required(t('CONFIRM_PASSWORD.CONFIRM_PASSWORD_REQUIRED')),
});

// @ts-ignore
export const getResetPasswordDetailSchema = (t): Yup.SchemaOf<ChangePasswordFieldsType> => Yup.object<Shape<ChangePasswordFieldsType>>().shape({
	[CHANGE_PASSWORD_FORM_FIELDS.NEW_PASSWORD]: Yup.string()
		.matches(PASSWORD_REG_EXP.latter, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION1'))
		.matches(PASSWORD_REG_EXP.uppercase, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION2'))
		.matches(PASSWORD_REG_EXP.number, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION3'))
		.matches(PASSWORD_REG_EXP.symbol, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION4'))
		.matches(PASSWORD_REG_EXP.complete, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION5'))
		.min(8, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION6'))
		.max(50, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION7'))
		// .required(t('CONFIRM_PASSWORD.NEW_PASSWORD_REQUIRED')),
		.required('New password is required'),
	[CHANGE_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD]: Yup.string()
		.oneOf([Yup.ref('newPassword'), null], t('CONFIRM_PASSWORD.PASSWORD_MATCH'))
		.required(t('CONFIRM_PASSWORD.CONFIRM_PASSWORD_REQUIRED')),
});

export const initialChangePasswordValues = {
	[CHANGE_PASSWORD_FORM_FIELDS.OLD_PASS]: '',
	[CHANGE_PASSWORD_FORM_FIELDS.NEW_PASSWORD]: '',
	[CHANGE_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD]: '',
};

export const getFormattedChangePasswordFormFields = (formikValues: {[key: string]: string}): ChangePasswordFieldsReturnType => ({
	currentPassword: formikValues?.[CHANGE_PASSWORD_FORM_FIELDS.OLD_PASS],
	newPassword: formikValues?.[CHANGE_PASSWORD_FORM_FIELDS.NEW_PASSWORD]
});

export interface IChangePasswordFields {
	username?: string,
	currentPassword: string,
	newPassword: string
}
